import { TableCell, Tooltip } from "@mui/material";
import { RiErrorWarningLine } from "react-icons/ri";
import { shortenAddressLength } from "../helpers/address";
import { OfferType } from "./tabs/account/accountRows";
import Link from "next/link";
import { helperConstants as constants } from "../helpers/helperConstants";

export const getBalanceAlert = (offer: OfferType) => {
  const notEnoughBalanceAlert =
    typeof offer?.hasEnoughBalance !== "undefined" && !offer?.hasEnoughBalance;
  const notApprovedEnoughAlert =
    !notEnoughBalanceAlert &&
    typeof offer?.isApprovedEnough !== "undefined" &&
    !offer?.isApprovedEnough;

  const TooltipContent = ({
    address,
    text,
  }: {
    address: string;
    text: string;
  }) => (
    <div className="text-2xs">
      User&nbsp;
      <Link href={`${constants.helpers.marketplace_url}/user/${address}`}>
        <a target="_blank" className="underline">
          {shortenAddressLength(address, 7)}
        </a>
      </Link>
      &nbsp; {text}
    </div>
  );

  const notEnoughBalanceTooltip = notEnoughBalanceAlert ? (
    <TooltipContent address={offer?.issuer} text="has not enough balance" />
  ) : null;
  const notApprovedEnoughTooltip = notApprovedEnoughAlert ? (
    <TooltipContent address={offer?.issuer} text="has not approved enough" />
  ) : null;

  return {
    className: notEnoughBalanceAlert
      ? "alert-info"
      : notApprovedEnoughAlert
      ? "alert-error"
      : "",
    Element: () => (
      <>
        {notEnoughBalanceAlert || notApprovedEnoughAlert ? (
          <TableCell
            align="center"
            classes={{
              root: "!border-none dark:text-white !flex",
            }}
          >
            <Tooltip
              //   title={`${notEnoughBalanceMessage ?? notApprovedEnoughMessage}`}
              title={notEnoughBalanceTooltip ?? notApprovedEnoughTooltip}
              placement="top"
              arrow
            >
              <button className="font-display text-sm font-semibold text-accent hover:text-accent-light dark:text-white">
                <RiErrorWarningLine size={20} />
              </button>
            </Tooltip>
          </TableCell>
        ) : null}
      </>
    ),
  };
};
